import {
  patchState,
  signalStore,
  withHooks,
  withMethods,
  withState,
} from '@ngrx/signals';
import { LocalStorage } from '../enums/local-storage';
import { LocatingSpace } from '@interfaces/location/locating-space';
import { LocationDataPayload } from '@interfaces/location/location-data-response';
import { RoomLocation } from '@interfaces/location/room-location';

interface RoomLocationState {
  generalLocations: RoomLocation[];
  locatingSpaces: LocatingSpace[];
}

export const initialValue: RoomLocationState = {
  generalLocations: [],
  locatingSpaces: [],
};

export const RoomLocationStore = signalStore(
  { providedIn: 'root' },
  withState(initialValue),
  withMethods(({ ...store }) => ({
    setLocations(locations: LocationDataPayload) {
      localStorage.setItem(
        LocalStorage.ROOM_LOCATION,
        JSON.stringify(locations),
      );
      patchState(store, {
        generalLocations: locations.general ?? [],
        locatingSpaces: locations.locatingSpaces ?? [],
      });
    },
  })),
  withHooks({
    onInit({ ...store }) {
      const locationAsString = localStorage.getItem(LocalStorage.ROOM_LOCATION);
      if (locationAsString) {
        const locations: LocationDataPayload = JSON.parse(locationAsString);
        patchState(store, {
          generalLocations: locations.general ?? [],
          locatingSpaces: locations.locatingSpaces ?? [],
        });
      }
    },
    onDestroy() {
      localStorage.removeItem(LocalStorage.ROOM_LOCATION);
    },
  }),
);
